import { render, staticRenderFns } from "./DoctorRecommendRewardDetails.vue?vue&type=template&id=773aaa98&scoped=true"
import script from "./DoctorRecommendRewardDetails.vue?vue&type=script&lang=js"
export * from "./DoctorRecommendRewardDetails.vue?vue&type=script&lang=js"
import style0 from "./DoctorRecommendRewardDetails.vue?vue&type=style&index=0&id=773aaa98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773aaa98",
  null
  
)

export default component.exports